import { useMutation } from 'react-query';
import axios, { AxiosProgressEvent } from 'axios';
import { useState } from 'react';
import { errorToast } from 'components/toasts/error';

export interface UploadData {
  url: string;
  file: File;
  contentType?: string;
  id?: number;
}

interface IProgress {
  loaded: number;
  total: number;
  percentage: number;
}

const S3UploadService = async (
  data: UploadData,
  onProgress?: (progress: IProgress) => void
): Promise<any> => {
  const { url, file, contentType } = data;
  const isFirefox = navigator?.userAgent?.indexOf('Firefox') !== -1;

  const config = {
    onUploadProgress: (progressEvent: AxiosProgressEvent) => {
      if (onProgress) {
        const { loaded, total } = progressEvent;
        const totalSize = total || 0; // Fallback to 0 if total is undefined
        const percentCompleted = Math.round((loaded * 100) / totalSize);
        onProgress({
          loaded: Math.floor(loaded / 1024),
          total: Math.floor(totalSize / 1024),
          percentage: percentCompleted,
        });
      }
    },
  };

  const response = await axios.put(url, file, {
    headers: {
      'content-type': !isFirefox && contentType ? contentType : file.type,
    },
    ...config,
  });

  return response;
};

export const useS3UploadMutation = () => {
  const [uploadToS3Progress, setUploadToS3Progress] = useState<IProgress>({
    loaded: 0,
    total: 0,
    percentage: 0,
  });
  return {
    ...useMutation(
      (data: UploadData) => S3UploadService(data, setUploadToS3Progress),
      {
        onError: () => {
          errorToast({ title: 'Something went wrong' });
        },
      }
    ),
    progress: uploadToS3Progress,
  };
};
